<template>
   
  <div class="d-lg-flex half">
    <div class="bg order-1 order-md-2" style="background-image: url('images/CreadorDeContenidoIA.png');"></div>
    <div class="contents order-2 order-md-1">

      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-md-7">            
            <h3>Ingresa al <strong>Creador de Contenido IA</strong></h3>
            <p class="mb-4"></p>
            <form @submit.prevent="login">
              <div class="form-group first">
                <label for="username">Correo Electrónico</label>
                <input type="email" class="form-control" v-model="formLogin.email" placeholder="johndoe@email.com" id="username" required>
              </div>
              <div class="form-group last mb-3">
                <label for="password">Contraseña</label>
                <input type="password" class="form-control" v-model="formLogin.password" placeholder="*******" id="password" required>
              </div>
              
              <div class="d-flex mb-5 align-items-center">                            
                <span class="ml-auto"><a v-b-modal.restablecer @click="mostrar_mensaje=false; mostrar_load = false;" class="forgot-pass">Olvidé Mi Contraseña</a></span> 
              </div>

              <input type="submit" value="Iniciar Sesión" class="btn btn-block btn-primary">

            </form>
            <br>
            <router-link to="/registro" class="btn btn-block btn-secundary">¡Crear Cuenta!</router-link>
            <!-- <b-img 
              src="images/LogoCreadorContenido.png"               
              v-bind="mainProps">
            </b-img> -->

            <b-modal id="restablecer" title="Restablecer Contraseña" hide-footer>
              
              <form @submit.prevent="restablecerPassword">
                <p>Danos más detalles sobre tu cuenta.</p>
                <div class="form-group first">
                  <label for="username">Escribe tu correo electrónico</label>
                  <input type="email" class="form-control" v-model="form_restablecer.email" placeholder="correo@gmail.com" required>
                </div>                
                <div class="d-flex align-items-center" v-if="mostrar_load">
                  <strong>Restableciendo Contraseña...</strong>
                  <b-spinner class="ml-auto"></b-spinner>
                </div>

                <input type="submit" value="Restablecer" class="btn btn-primary">
                <br><br>
                <b-alert show variant="primary" v-if="mostrar_mensaje">{{mensaje_restablecer}}</b-alert>

              </form>

            </b-modal>
            
          </div>
        </div>
      </div>
    </div>      
  </div>
  
</template>
<script>
import {headers} from './../../api/headers'
import {configApi} from './../../api/configApi'
export default {
  data: () => ({
    mainProps: { width: 130, height: 100 },
    showPassword: false,
    alert: false,
    colorAlert: "",
    textAlert: "",
    colorBtnAlert: "",
    formLogin: {
      email: "",
      password: ""
    },    
    mostrar_load: false,
    mostrar_mensaje: false,
    form_restablecer: {
      email: ''
    } 
  }),
  methods: {
    login() {
      if(this.formLogin.email !== null || this.formLogin.password !== null) {
        this.$store.dispatch("retrieveToken", {
          email: this.formLogin.email,
          password: this.formLogin.password
        }).then(response => {
          this.$router.push({name:"plataformas"})  
          window.location.reload()          
        }).catch(error => {
          console.log(error)
          this.$Fun.alertaAccion('error', 'Correo Electrónico o Contraseña incorrecta', true)
        })
      }      
    },
    async restablecerPassword () {  
      this.mostrar_load = true    
      return await this.axios.post(configApi+'restablecer', this.form_restablecer, {headers})
      .then(response => {        

        this.$Fun.alertaAccion('success', response.data.message, false)

        if(response.data.data.id > 0) {
          this.form_restablecer.email = ''   
          this.mostrar_mensaje = true    
          this.mostrar_load = false   
          this.mensaje_restablecer = 'Tu contraseña ha cambiado, revisa la bandeja de entrada ó spam de tu correo electrónico.'
        } else {
          this.mostrar_load = false
        }
                    
      })
    }
  }
}
</script>
<style>
body {
  font-family: "Roboto", sans-serif;
  background-color: #fff; }

p {
  color: #b3b3b3;
  font-weight: 300; }

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  font-family: "Roboto", sans-serif; }

a {
  -webkit-transition: .3s all ease;
  -o-transition: .3s all ease;
  transition: .3s all ease; }
  a:hover {
    text-decoration: none !important; }

.content {
  padding: 7rem 0; }

h2 {
  font-size: 20px; }

.half, .half .container > .row {
  height: 100vh; }

@media (max-width: 991.98px) {
  .half .bg {
    height: 500px; } }

.half .contents, .half .bg {
  width: 50%; }
  @media (max-width: 1199.98px) {
    .half .contents, .half .bg {
      width: 100%; } }
  .half .contents .form-group, .half .bg .form-group {
    margin-bottom: 0;
    border: 1px solid #efefef;
    padding: 15px 15px;
    border-bottom: none; }
    .half .contents .form-group.first, .half .bg .form-group.first {
      border-top-left-radius: 7px;
      border-top-right-radius: 7px; }
    .half .contents .form-group.last, .half .bg .form-group.last {
      border-bottom: 1px solid #efefef;
      border-bottom-left-radius: 7px;
      border-bottom-right-radius: 7px; }
    .half .contents .form-group label, .half .bg .form-group label {
      font-size: 12px;
      display: block;
      margin-bottom: 0;
      color: #b3b3b3; }
  .half .contents .form-control, .half .bg .form-control {
    border: none;
    padding: 0;
    font-size: 20px;
    border-radius: 0; }
    .half .contents .form-control:active, .half .contents .form-control:focus, .half .bg .form-control:active, .half .bg .form-control:focus {
      outline: none;
      -webkit-box-shadow: none;
      box-shadow: none; }

.half .bg {
  background-size: cover;
  background-position: center; }

.half a {
  color: #888;
  text-decoration: underline; }

.half .btn {
  height: 54px;
  padding-left: 30px;
  padding-right: 30px; }

.half .forgot-pass {
  position: relative;
  top: 2px;
  font-size: 14px; }

.control {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 15px;
  cursor: pointer;
  font-size: 14px; }
  .control .caption {
    position: relative;
    top: .2rem;
    color: #888; }

.control input {
  position: absolute;
  z-index: -1;
  opacity: 0; }

.control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #e6e6e6;
  border-radius: 4px; }

.control--radio .control__indicator {
  border-radius: 50%; }

.control:hover input ~ .control__indicator,
.control input:focus ~ .control__indicator {
  background: #ccc; }

.control input:checked ~ .control__indicator {
  background: #007bff; }

.control:hover input:not([disabled]):checked ~ .control__indicator,
.control input:checked:focus ~ .control__indicator {
  background: #1a88ff; }

.control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.9;
  pointer-events: none; }

.control__indicator:after {
  font-family: 'icomoon';
  content: '\e5ca';
  position: absolute;
  display: none;
  font-size: 16px;
  -webkit-transition: .3s all ease;
  -o-transition: .3s all ease;
  transition: .3s all ease; }

.control input:checked ~ .control__indicator:after {
  display: block;
  color: #fff; }

.control--checkbox .control__indicator:after {
  top: 50%;
  left: 50%;
  margin-top: -1px;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%); }

.control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b; }

.control--checkbox input:disabled:checked ~ .control__indicator {
  background-color: #7e0cf5;
  opacity: .2; }
</style>